
import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

import * as _ from 'lodash';
import { DispatchSearch } from '../DispatchSearch';
import { v_DispatchSearchBus } from '../models/v_DispatchSearchBus';
import { WidgetSearch } from '../models/WidgetSearch';
import { FileInfo } from '@progress/kendo-angular-upload';
import { AttachmentBus } from '../models/AttachmentBus';
import { v_DispatchPartsOrderedBus } from '../models/v_DispatchPartsOrderedBus';
import { v_DispatchAttachmentBus } from '../models/v_DispatchAttachmentBus';
import { DispatchAssignmentBus } from '../models/DispatchAssignmentBus';
import { CommonParam } from '../models/CommonParam';
import { PersonNotificationParam } from '../models/PersonNotificationParam';
import { SystemEventSubscriptionsBus } from '../models/SystemEventSubscriptionsBus';

@Injectable()
export class SystemService extends BaseService {

    constructor(_http: HttpClient) {
        super(_http);
        this.baseUrl = this.rootUrl + "System/";
    }

    getPersonNotifications(appCode: string, primaryId: any): Observable<any> {
        let url_call: string = this.baseUrl + "GetPersonNotifications/" + appCode +"/" + primaryId;
        return super.get(url_call);
    }
    saveSystemEventSubscription(model: SystemEventSubscriptionsBus): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveSystemEventSubscriptions";
        return this._http.put(url_call, model, { headers });
    }
    deleteSystemEventSubscriptions(id: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteSystemEventSubscriptions/" + id;
        return this._http.delete(url_call, { headers });
    }
    savePersonNotifications(model: PersonNotificationParam): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SavePersonNotifications";
        return this._http.put(url_call, model, { headers });
    }
    getSystemEventSubscriptions(): Observable<any> {
        //let s_param: string = param.bidSheetDetailId;
        //let url_call: string = this.baseUrl + "getbidsheetdetails/" + s_param;
        let url_call: string = this.baseUrl + "GetSystemEventSubscriptions";
        return this.get(url_call);
    }
    getSystemEvents(): Observable<any> {
        //let s_param: string = param.bidSheetDetailId;
        //let url_call: string = this.baseUrl + "getbidsheetdetails/" + s_param;
        let url_call: string = this.baseUrl + "GetSystemEvents";
        return this.get(url_call);
    }

}
